import { render, staticRenderFns } from "./PackagesListing.vue?vue&type=template&id=937ed868&scoped=true&lang=pug&"
import script from "./PackagesListing.vue?vue&type=script&lang=js&"
export * from "./PackagesListing.vue?vue&type=script&lang=js&"
import style0 from "./PackagesListing.vue?vue&type=style&index=0&id=937ed868&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "937ed868",
  null
  
)

export default component.exports